export const hyMap: Record<string, any> = {
  welcome: {
    title: "Բարի գալուստ ակտիվների կառավարման հարթակ",
    subtitle: "Լրացրեք ձեր տվյալները ստորև",
    trailingText:
      "Ձեր տվյալները պահվում են անվտանգ տվյալների բազայում: Մենք երբեք չենք կիսի ձեր տվյալները որևէ մեկի հետ",
    demoText: "Որպես հյուր մուտք գործելու համար կարող եք նաև օգտագործել հետևյալ տվյալները",
    email: "էլ. հասցե",
    password: "Գաղտնաբառ",
  },
  signin: {
    form: {
      emailLabel: "էլ. հասցե",
      emailPlaceholder: "էլ. հասցե",

      passwordLabel: "Գաղտնաբառ",
      passwordPlaceholder: "Գաղտնաբառ",

      submit: "Մուտք գործեք",
    },
  },
  dashboard: {
    inputSelect: "Ընտրել",
    inputEnter: "Մուտքագրեք",
    navbarTitle: "Գլխավոր էջ",

    sidebar: {
      dashboardLabel: "Գլխավոր էջ",
      assetsLabel: "Ակտիվներ",
      usersLabel: "Օգտատերեր",
      rolesLabel: "Դերեր",
      professionsLabel: "Պաշտոններ",
      checkLabel: "Ստուգում",
      "check-assetsLabel": "Ստուգում",
      requestsLabel: "հայտեր",
      typesLabel: "Ակտիվների տեսակները",
      accountLabel: "Հաշիվ",
      logout: "Դուրս գալ",
      aboutLabel: "Մեր մասին",
      contactLabel: "Կապ մեզ հետ",
    },

    onPageSearchInputLabel: "էջի որոնում",
    onPageSearchInputPlaceholder: "Մուտքագրեք որոնման հիմնաբառը...",

    filterByType: "Ֆիլտրել ըստ տեսակի",

    user: {
      welcome: "Բարի գալուստ ակտիվների կառավարման հարթակ",
      accordion: {
        title1: "Ի՞նչ է իրենից ներկայացնում Invasman-ը",
        description1:
          "Գույքագրման ակտիվների կառավարման համակարգը համապարփակ ծրագրային լուծում է, որը նախատեսված է կազմակերպությունում ֆիզիկական ակտիվների հսկումը, մոնիտորինգը և կառավարումը պարզեցնելու համար: Այն օգտվողներին տրամադրում է կենտրոնացված հարթակ՝ արդյունավետորեն վերահսկելու ակտիվների կյանքի ցիկլերը՝ ներմուծումից մինչև դուրս գրում։ Կայքը նպատակ ունի վերասահմանել արդյունավետության, ֆունկցիոնալության և օգտատերերի բավարարվածության նոր չափանիշները ակտիվների կառավարման ոլորտում: Ի վերջո, գույքագրման ակտիվների կառավարման համակարգը բիզնեսին հնարավորություն է տալիս տեղեկացված որոշումներ կայացնել, նվազագույնի հասցնելով ակտիվների թերօգտագործումը,ռեսուրսների չարաշահումը և առավելագույնի հասցնելով ներդրումների վերադարձը:",

        title2: "Ինչպես են ակտիվները կառավարվում",
        description2:
          "Ձեռք բերեք ամբողջական տեսանելիություն և վերահսկողություն կազմակերպության ներսում ձեզ կցված բոլոր ակտիվների նկատմամբ: Մեր համապարփակ ակտիվների կառավարման համակարգը մանրամասն պատկերացումներ է տալիս ձեր պատասխանատվության տակ գտնվող յուրաքանչյուր ակտիվի վերաբերյալ: Հետևեք ակտիվներին իրենց եզակի նույնականացման ցուցիչներով , ինչպիսիք են UUID-ը կամ ակտիվների կատեգորիաները: Կենտրոնացնելով ակտիվների մասին տեղեկատվությունը, դուք կարող եք արդյունավետ կառավարել ակտիվների ճիշտ օգտագործումը, նվազագույնի հասցնել կորուստը կամ թեչօգտագործումը և ապահովել ակտիվների օպտիմալ կառավարում։",

        title3: "Եղեք տեղեկացված ձեր հայտերի կարգավիճակի մասին",
        description3:
          "Հեշտությամբ հետևեք ձեր բոլոր ակտիվների հայտերին սկզբից մինչև վերջ՝ ի շնորհիվ մեր հայտերի կարգավիճակի թափանցիկ փոփոխվելու հնարավորությանը: Ներկայացրեք, ստուգեք և կարգավորեք հայտերն առանց ջանքերի պարզ ինտերֆեյսի միջոցով: Հետևեք առկախ հայտերին և ծանուցվեք, երբ դրանք կավարտվեն: Դիտեք անցյալ հայտերի ամբողջական ցանկը, ներառյալ՝ երբ և ինչու եք դրանք ներկայացրել,, ինչ եք խնդրել և արդյոք դրանք հաստատվել են : Ձեր հայտերի պատմության իմացությունն ու պարբերաբար հետևումն օգնում է ձեզ հեշտացնել ավելի արդյունավետ օգտագործել ռեսուրսները:",

        title4: "Պահպանեք ձեր պրոֆիլի վերահսկողությունը և անվտանգությունը",
        description4:
          "Դուք կարող եք հեշտությամբ փոփոխել և թարմացնել ձեր պրոֆիլի տվյալները ինչպես նաև անվտանգ պահել ձեր մուտքի տվյալները: Մուտքի տվյալները ստանալուց հետո խորհորրդ է տրվում անմիջապես փոփոխել գաղտանաբառը հետևելով կայքում գործող սահմանափակումներին։",
      },
    },
    monitoring: {
      requestsBarTitle: "Հայտերի մոնիտորինգի բար",
      requestsAreaTitle: "Հայտերի մոնիտորինգ",

      assetTypes: "տեսակներ",
      availableAssets: "Առկա ակտիվներ",
      pendingRequests: "հայտեր",
      registeredAccounts: "օգտատերեր",
      professions: "պաշտոններ",

      availableAssetsByType: "Հասանելի ակտիվներ ըստ տեսակի",
      count: "Քանակ",
      assetsCount: "Ակտիվների քանակ",
    },
    requests: {
      create: "Ստեղծել",
      discard: "Չեղարկել",
      newRequest: "նոր հայտ",

      seeAllPending: "Տեսնել բոլոր սպասող հայտերը",
      pendingRequestsMessage: "Դուք ունեք {{count}} սպասող հայտ",

      replacementYes: "Այո",
      replacementNo: "Ոչ",

      deleteSelected: "Ջնջել ընտրված հայտերը",

      approveSelected: "Հաստատել ընտրված հայտերը",
      declineSelected: "Մերժել ընտրված հայտերը",

      selectAsset: "Ընտրեք ակտիվը",
      selectNotRequestedAsset: "Ընտրեք ակտիվը, որը չի հարցվել",

      filterStatusPlaceholder: "Կարգավիճակը",

      headers: {
        id: "id",
        status: "Կարգավիճակ",
        action: "Որոշման ամսաթիվ",
        reason: "Պատճառ",
        replacement: "Փոխանակում",
        asset: "Ակտիվ",
        created: "Ստեղծման ամսաթիվ",
        owner: "Սեփականատեր",
      },

      filterByStatus: "Ֆիլտրել ըստ վիճակի",
    },
    assets: {
      create: "Ստեղծել",
      discard: "Չեղարկել",
      newAsset: "նոր ակտիվ",

      assignToUser: "Կցել օգտատիրոջը",

      checkNoticeToday: "Դուք այսօր ստուգելու ակտիվներ ունեք: Խնդրում ենք ստուգել դրանք որքան հնարավոր է շուտ:",

      unassignSelected: "Չեղարկել ընտրված ակտիվների կցումը",
      deleteSelected: "Ջնջել ընտրված ակտիվները",

      countPlaceholder: "Քանակը",

      markAssetsAsChecked: "Նշել ակտիվները ստուգված",

      headers: {
        id: "id",
        uuid: "uuid",
        name: "Անվանումը",
        type: "Տեսակը",
        createdAt: "Ստեղծվել է",
        checkDate: "Ստուգման ամսաթիվ",
        user: "Օգտատեր",
      },
    },
    users: {
      filterByRole: "Ֆիլտրել ըստ դերի",

      headers: {
        id: "id",
        name: "Անուն",
        lastname: "Ազգանուն",
        username: "Հաշվի անվանում",
        email: "Էլ․ հասցե",
        password: "Գաղտնաբառ",
        registered: "գրանցված",
        avatar: "ավատար",
        role: "Դեր",
        profession: "Պաշտոն",
        actions: "Փոփոխել",
      },

      create: "Ստեղծել",
      discard: "Չեղարկել",
      newUser: "նոր օգատատեր",

      deleteSelected: "Ջնջել ընտրված օգտատերերին",
    },
    roles: {
      headers: {
        id: "id",
        name: "Անվանում",
        accessLevel: "Հասանելիության աստիճան",
        description: "Նկարագրություն",
      },

      labels: {
        admin: "Ղեկավար",
        moderator: "Մենեջեր",
        user: "Օգտատեր",
      },

      descriptions: {
        admin: "Ամբողջական վերահսկողություն և արտոնություններ",
        moderator: "Մասնակի վերահսկման և կառավարման կարողություններ",
        user: "Սահմանափակ մուտք և հիմնական ֆունկցիոնալություն",
      },
    },
    professions: {
      create: "Ստեղծել",
      discard: "Չեղարկել",
      newProfession: "նոր պաշտոն",

      deleteSelected: "Ջնջել ընտրված պաշտոնները",

      descriptionPlaceholder: "Նկարագրությունը",
      selectAssetsLabel: "Ընտրեք ակտիվները",

      headers: {
        id: "id",
        name: "Անվանում",
        description: "Նկարագրություն",
        assets: "Ակտիվներ",
      },
    },
    types: {
      create: "Ստեղծել",
      discard: "Չեղարկել",
      newType: "նոր տեսակ",

      deleteSelected: "Ջնջել ընտրված տեսակները",

      descriptionPlaceholder: "Նկարագրությունը",

      headers: {
        id: "id",
        name: "Անվանում",
        description: "Նկարագրություն",
      },
    },
    account: {
      nameInputLabel: "Անուն",
      lastnameInputLabel: "Ազգանուն",
      usernameInputLabel: "Հաշվի անվանում",
      emailInputLabel: "Էլ. հասցե",

      currentPasswordInputLabel: "Ներկայիս գաղտնաբառը",
      currentPasswordPlaceholder: "Մուտքագրեք Ներկայիս գաղտնաբառը",

      newPasswordInputLabel: "Նոր գաղտնաբառ",
      newPasswordPlaceholder: "Մուտքագրեք Նոր գաղտնաբառը",

      confirmPasswordInputLabel: "Հաստատել գաղտնաբառը",
      confirmPasswordPlaceholder: "Մուտքագրեք Նոր գաղտնաբառը",

      updatePasswordButton: "Փոխել գաղտնաբառը",

      allPasswordsRequired: "Բոլոր գաղտնաբառերը պարտադիր են",
      passwordsDoNotMatch: "Նոր գաղտնաբառը և հաստատման գաղտնաբառը պետք է լինեն նույնը",

      securityDescription:
        "Հաշվի տեղեկատվությունը ապահովված է և գաղտնի: Խնդրում ենք զգույշ լինել ձեր տվյալները փոփոխելիս: Անվտանգության և գաղտնիության պահպանման նպատակով գաղտնաբառը փոխելուց հետո դուք ավտոմատ կերպով դուրս կգաք համակարգից,որից հետո կարող եք մուտք գործել կրկին նոր գաղտնաբառը մուտքագրելով",

      autogeneratedAvatar: "Սա ինքնագեներացված ավատար է ձեր հաշվի համար",

      passwordRequirements: {
        title: "Գաղտնաբառը պետք է պարունակի",
        length: "Առնվազն 6 նիշ",
        uppercase: "Առնվազն 1 մեծատառ",
        lowercase: "Առնվազն 1 փոքրատառ",
        number: "Առնվազն 1 թվանշան",
      },
    },
    contact: {
      title: "Հետադարձ Կապ",
      description:
        "Մենք այստեղ ենք ձեզ օգնելու համար: Եթե ունեք հարցեր կամ օգնության կարիք ապա խնդրում ենք անմիջապես կապվել մեզ հետ: Մենք հնարավորինս շուտ կապ կհաստատենք Ձեզ հետ:",
      emailLabel: "Ուղարկեք էլ. նամակ",
      manualLabel: "Մեր էլեկտրոնային հասցեն է",
    },
    about: {
      title: "Ծանոթություն",
      description:
        "Կայքի այս հատվածում դուք կգտնեք ձեզ անհրաժեշտ բոլոր հարցերի պատասխանները: Եթե ունեք այլ հուզող հարցեր, խնդրում ենք մի հապաղեք կապվել մեզ հետ:",

      accordion: {
        title1: "Ի՞նչ է իրենից ներկայացնում Invasman-ը",
        description1:
          "Գույքագրման ակտիվների կառավարման համակարգը համապարփակ ծրագրային լուծում է, որը նախատեսված է կազմակերպությունում ֆիզիկական ակտիվների հսկումը, մոնիտորինգը և կառավարումը պարզեցնելու համար: Այն օգտվողներին տրամադրում է կենտրոնացված հարթակ՝ արդյունավետորեն վերահսկելու ակտիվների կյանքի ցիկլերը՝ ներմուծումից մինչև դուրս գրում։ Կայքը նպատակ ունի վերասահմանել արդյունավետության, ֆունկցիոնալության և օգտատերերի բավարարվածության նոր չափանիշները ակտիվների կառավարման ոլորտում: Ի վերջո, գույքագրման ակտիվների կառավարման համակարգը բիզնեսին հնարավորություն է տալիս տեղեկացված որոշումներ կայացնել, նվազագույնի հասցնելով ակտիվների թերօգտագործումը,ռեսուրսների չարաշահումը և առավելագույնի հասցնելով ներդրումների վերադարձը:",

        title2: "Ակտիվերի կառավարման կարևորությունը",
        description2:
          "Ակտիվների կառավարումը կարևոր է բոլոր չափերի և ոլորտների կազմակերպությունների համար: Ակտիվների կառավարման արդյունավետ համակարգ ներդնելով՝ ձեռնարկությունները կարող են օպտիմալացնել ակտիվների օգտագործումը, նվազեցնել գործառնական ծախսերը և բարձրացնել արտադրողականությունը: Ակտիվների կառավարումը նաև օգնում է կազմակերպություններին համապատասխանել կարգավորող պահանջներին, նվազեցնել ռիսկերը և բարելավել որոշումների կայացման գործընթացները: Ի վերջո, ակտիվների կառավարումը բիզնեսին հնարավորություն է տալիս առավելագույնի հասցնել իրենց ակտիվների արժեքը և հասնել երկարաժամկետ հաջողությունների:",

        title3: "Մեր առաքելությունը և տեսլականը",
        description3:
          "Մեր առաքելությունն է կազմակերպություններին տրամադրել հզոր և օգտագործողի համար հարմար հարթակ՝ իրենց ակտիվներն արդյունավետ կառավարելու համար: Մենք հավատարիմ ենք տրամադրելու նորարարական լուծումներ, որոնք հեշտացնում են ակտիվների կառավարման գործընթացները, բարձրացնում տեսանելիությունը և խթանում գործառնական արդյունավետությունը: Մեր տեսլականն է դառնալ ակտիվների կառավարման ծրագրային ապահովման առաջատար մատակարարը, որը հնարավորություն կտա ձեռնարկություններին հասնել իրենց նպատակներին և մրցունակ մնալ դինամիկ կերպով զարգացող շուկայում՝ խթանելով վերջիններիս զագացման աճը:",

        title4: "Ինչու՞ ընտրել Invasman-ը",
        description4:
          "Invasman-ը ակտիվների կառավարման իդեալական լուծում է այն ձեռնարկությունների համար, որոնք ցանկանում են օպտիմալացնել իրենց ակտիվների կառավարման գործընթացները: Մեր հարթակն առաջարկում է մի շարք առանձնահատկություններ և գործառույթներ, որոնք նախատեսված են տարբեր ոլորտներում կազմակերպությունների տարբեր պահանջները բավարարելու համար: Սկսած ակտիվների հետևումից և գույքագրման վերահսկումից մինչև կառավարում և ակտիվների բաշխում, Invasman-ը տրամադրում է այն ամենը, ինչ անհրաժեշտ է ձեր ակտիվները արդյունավետ կառավարելու համար: Մեր ինտուիտիվ ինտերֆեյսի և կայուն անվտանգության առանձնահատկությունների շնորհիվ Invasman-ը ճիշտ ընտրություն է ձեռնարկությունների համար, ովքեր փնտրում են ակտիվների կառավարման հուսալի լուծում:",

        title5: "Կապ մեզ հետ",
        description5:
          "Եթե ունեք հարցեր Invasman-ի վերաբերյալ կամ ցանկանում եք ավելին իմանալ մեր ակտիվների կառավարման ծրագրաշարի մասին, խնդրում ենք մի հապաղեք կապվել մեզ հետ: Մենք այստեղ ենք՝ օգնելու և տրամադրելու ձեզ անհրաժեշտ տեղեկատվություն՝ տեղեկացված որոշում կայացնելու համար: Կապվեք մեզ հետ այսօր՝ պարզելու, թե ինչպես Invasman-ը կարող է օգնել ձեզ օպտիմալացնել ձեր ակտիվների կառավարման գործընթացները և հասնել ձեր բիզնես նպատակներին:",
      },
    },
  },
};
